export enum ActivityLogAction {
  CREATE_REQUEST = 'CREATE_REQUEST',
  UPDATE_REQUEST = 'UPDATE_REQUEST',
  DELETE_REQUEST = 'DELETE_REQUEST',
  ADD_COMMENT = 'ADD_COMMENT',
  ADD_ATTACHMENT = 'ADD_ATTACHMENT',
  DELETE_ATTACHMENT = 'DELETE_ATTACHMENT',
  APPROVE_REQUEST_STAGE = 'APPROVE_REQUEST_STAGE',
  REJECT_REQUEST_STAGE = 'REJECT_REQUEST_STAGE',
  REVIEW_REQUEST_STAGE = 'REVIEW_REQUEST_STAGE',
  SUBMITTED_TO_REVIEW_STAGE = 'SUBMITTED_TO_REVIEW_STAGE',
  SUBMITTED_REVIEW_CLEARANCE_STAGE = 'SUBMITTED_REVIEW_CLEARANCE_STAGE',
}

export const actionToActiveStatement = (action: string) => {
  switch (action) {
    case ActivityLogAction.CREATE_REQUEST:
      return 'created the request'
    case ActivityLogAction.UPDATE_REQUEST:
      return 'updated the request'
    case ActivityLogAction.DELETE_REQUEST:
      return 'deleted the request'
    case ActivityLogAction.ADD_COMMENT:
      return 'added a comment'
    case ActivityLogAction.ADD_ATTACHMENT:
      return 'added an attachment'
    case ActivityLogAction.DELETE_ATTACHMENT:
      return 'deleted an attachment'
    case ActivityLogAction.APPROVE_REQUEST_STAGE:
      return 'approved the request'
    case ActivityLogAction.REJECT_REQUEST_STAGE:
      return 'rejected the request'
    case ActivityLogAction.REVIEW_REQUEST_STAGE:
      return 'reviewed the request'
    case ActivityLogAction.SUBMITTED_TO_REVIEW_STAGE:
      return 'submitted for review/approval'
    case ActivityLogAction.SUBMITTED_REVIEW_CLEARANCE_STAGE:
      return 'submitted review clearance'
    default:
      return ''
  }
}
